import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setStage, resetState, checkImeiForVolte, setLoading, openWorkOrder} from '../VolteCheckSlice';
import {stageEnums} from '../Assets/VolteCheckVariables';
import LocalLoader from '../../../Shared/Loader/LocalLoader';
import StartScreen from './Stages/startScreen';
import NotSupportedScreen from './Stages/notSupportedScreen';
import ActiveScreen from './Stages/activeScreen';
import ErrorScreen from './Stages/errorScreen';
import CallBackScreen from './Stages/callbackScreen';

const VolteCheckComponentDynamica = (props) => {
  useEffect(() => {
    return () => {
      props.resetState();
    };
  }, []);

  const getScreen = () => {
    switch (props.screenToShow) {
      case stageEnums.error:
        return <ErrorScreen {...props} />;
      case stageEnums.active:
        return <ActiveScreen {...props} />;
      case stageEnums.notSupported:
        return <NotSupportedScreen {...props} />;
      case stageEnums.callback:
        return <CallBackScreen {...props} />;
      case stageEnums.start:
      default:
        return <StartScreen {...props} />;
    }
  };
  return (
    <>
      {props.isLoading && <LocalLoader isDynamica={true} />}
      {getScreen()}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    screenToShow: state.volteCheckSlice.stageStep,
    data: state.volteCheckSlice,
    isLoading: state.volteCheckSlice.isLoading,
    subscribersByProduct: state.selfcarePage?.subscribersByProduct,
  };
};

const mapDispatchToProps = {setStage, resetState, checkImeiForVolte, setLoading, openWorkOrder};

export default connect(mapStateToProps, mapDispatchToProps)(VolteCheckComponentDynamica);
